import { questionnaireGql } from '../../../gql-gen/questionnaire'

export const DRAFT_TEXT_HIGHLIGHTER_ITEM = questionnaireGql(/* GraphQL */ `
  fragment DraftTextHighlighterItem on DraftTextHighlighterItem {
    question {
      ...Question
    }
    highlighterCategories {
      colour {
        hex
        label
      }
      responseOption {
        responseOptionId
        value
        translations {
          language
          value
        }
        localeTranslations {
          country
          translation {
            language
            value
          }
        }
      }
      position
    }
    content {
      text
      textStyling
    }
    translations {
      language
      text
      textStyling
      content {
        text
        textStyling
      }
    }
    localeTranslations {
      country
      translation {
        language
        text
        textStyling
        content {
          text
          textStyling
        }
      }
    }
    questionLogic {
      ...DraftLogicClauseProposition
    }
    settingValues {
      code
      value
    }
  }
`)
